module.exports = __webpack_public_path__ + "media/images/underline-bfc1f6fa.svg";